import React, { useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
//import { metadata } from "libphonenumber-js"; //already build in
import "react-phone-number-input/style.css";
//import USInput from "react-phone-number-input/input";

// this component include label, input text box
// required *, help/tip message, and error state with error message

// base on input props.isRequired, props.hasError
// update the className, to show error, and required

// use props.value to set phone number, need + at first char for country

// https://catamphetamine.gitlab.io/react-phone-number-input/
// https://www.npmjs.com/package/react-phone-number-input

const PhoneInputField = (props) => {

  const [value, setValue] = useState(props.value);

  // default onChange handler
  function defaultOnChange(e) {
    // onChange is return value to formik
    setValue(e);
    if (props.onChange !== undefined && props.onChange !== null) {
      props.onChange(e);
    } else {
      //console.log("no onChange function, value= " + e);
    }
  }

  function defaultOnBlur(e) {
    // check if number is valid
    let phoneNumberHasError = false;
    if (e !== undefined) {
      //console.log("is number valid = ", isValidPhoneNumber(e));
      //console.log("is US number =", e);
      if (!props.showFlag) {
        let str = "+1";
        e[0] === "1" ? (str = "+") : (str = "+1");
        e = str + e.replace(/[-]/g, " ").replace(/[()]/g, "");
      }
      //console.log("is US number =", e);
      phoneNumberHasError = isValidPhoneNumber(e);
    } else {
      //console.log("is number not valid = ", e);
    }

    // onChange is return object (number, and validtion) to formik
    if (props.onBlur !== undefined && props.onBlur !== null) {
      props.onBlur({ e, phoneNumberHasError });
    } else {
      //console.log("no OnBlur function, value= ", e);
    }
  }

  function defaultOnFocus(e) {
    if (props.onFocus !== undefined && props.onFocus !== null) {
      return true;
    }
    return false;
  }

  return (
    <div className="phoneinput__container">
      {/* display label */}
      <label
        className={`phoneinput__label ${
          props.hasError ? "phoneinput__label--error" : ""
        }
        ${props.isDisabled ? "phoneinput__label--disabled" : ""}

        ${props.showFlag ? "" : "phoneinput__hideFlag"}

        `}
      >
        {props.labelText}
        {/* display required * */}
        <span   
          id={props.isRequired ? "required" : "none"}
          title={props.isRequired ? "required" : "none"}     
          className="phoneinput__required"
          style={props.isRequired ? {} : { display: "none" }}
        >
          *
        </span>
        
        {/* phone input box */}
        <PhoneInput
          placeholder={props.showFlag ? "+1" : ""}
          value={value}
          defaultCountry={"US"}
          international={props.showFlag}
          withCountryCallingCode={props.showFlag}
          countryCallingCodeEditable={false}
          disabled={props.isDisabled}
          required={props.required}
          onChange={(e) => defaultOnChange(e)}
          onBlur={(e) => defaultOnBlur(e.target.value)}
          onFocus={(e) => defaultOnFocus(e)}
        />

        {/* display help message */}
        <span className="phoneinput__help">{props.helpMessage}</span>
        
        {/* display errorMessage or formik error message */}
        <span
          className="phoneinput__error"
          style={props.hasError ? {} : { display: "none" }}
        >
          {props.errorMessage}
        </span>
        
      </label>

      {/* US phone input only demo */}
      {/* <USInput
        country="US"
        value={value}
        onChange={setValue}
      /> */}
    </div>
  );
};

export default PhoneInputField;